import React, {FC} from 'react';
import cn from 'classnames';

import {Card} from '../../components/Card/Card';
import {Footer} from '../../components/Footer/Footer';
import {Header} from '../../components/Header/Header';
import {Question} from '../../components/Question/Question';
import {OFFER_ITK, OFFER_RNKO, OFFER_T2} from '../../config/routes';

import {Connect} from './Connect/Connect';
import {Cover} from './Cover/Cover';
import {HowToUse} from './HowToUse/HowToUse';
import {Structure} from './Structure/Structure';

import cls from './Index.module.scss'

const Index: FC = () => (
    <>
        <Header/>
        <Cover/>
        <div className={cls.wrapper}>
            <div className={cn(['content', cls.blocks])}>

                <Structure/>

                <HowToUse/>

                <Connect/>

                <Card color={'white'}>
                    <h2>Остались вопросы? ответим!</h2>
                    <div className={cls.columns}>
                        <div className={cls.column}>
                            <Question color={'gray'} question={<>По&nbsp;каким вопросам можно обращаться?</>} answer={
                                <ul>
                                    <li>По&nbsp;вопросам компенсации транспортных, юридических расходов, понесенных
                                        в&nbsp;результате оспаривания кредита, оформленного мошенническим путем.
                                        А&nbsp;также по&nbsp;вопросам компенсации государственной пошлины по&nbsp;замене
                                        документов, данные которых скомпрометированы
                                    </li>
                                    <li>Юридические консультации, предоставление типовых документов, а&nbsp;также
                                        подготовка заявления и&nbsp;консультация по&nbsp;списку документов в&nbsp;банк
                                        в&nbsp;случае выявления мошеннического кредита
                                    </li>
                                    <li>Онлайн сопровождению клиента в&nbsp;процессе взаимодействия его с&nbsp;полицией
                                        по&nbsp;вопросам: кражи денежных средств с&nbsp;банковской карты; незаконного
                                        оформления кредита третьими лицами без вашего участия и&nbsp;согласия.
                                    </li>
                                </ul>
                            }/>
                            <Question color={'gray'}
                                      question={<>Являются&nbsp;ли профессионалами специалисты, оказывающие
                                          консультации?</>}
                                      answer={<>Все сотрудники сервиса&nbsp;&mdash; дипломированные специалисты, которые
                                          проходят строгий отбор и&nbsp;обладают практическим опытом работы
                                          в&nbsp;юриспруденции.</>}/>
                            <Question color={'gray'} question={'Как отключить услугу?'} answer={
                                <>
                                    Отключить услугу вы&nbsp;можете на&nbsp;t2.ru в&nbsp;<a href={'https://t2.ru/lk'}
                                                                                            target={'_blank'}
                                                                                            rel={'noreferrer'}>личном
                                    кабинете</a> или
                                    в&nbsp;мобильном приложении t2&nbsp;в разделе &laquo;Услуги&raquo;.
                                </>
                            }/>
                        </div>
                        <div className={cls.column}>
                            <Question color={'gray'} question={'Как оказываются услуги?'} answer={
                                <ul>
                                    <li>Для получения денежного возмещения транспортных, юридических расходов,
                                        а&nbsp;также затрат на&nbsp;оплату государственной пошлины на&nbsp;замену
                                        документов, вам необходимо подать заявления, заполнив специальную форму
                                        на&nbsp;сайте компании по&nbsp;адресу: <a
                                            href={'https://fintechservice.group/loss'} target={'_blank'}
                                            rel={'noreferrer'}>https://fintechservice.group/loss</a>и&nbsp;следовать
                                        инструкциям.
                                    </li>
                                    <li>Для получения юридических консультаций вам необходимо заполнить форму
                                        на&nbsp;сайте компании по&nbsp;адресу <a
                                            href={'https://fintechservice.group/consultation'}
                                            target={'_blank'}
                                            rel={'noreferrer'}>https://fintechservice.group/consultation</a>
                                    </li>
                                </ul>
                            }/>
                            <Question color={'gray'} question={'Консультации оказываются сразу или нужно ждать ответа?'}
                                      answer={<>Консультации оказываются приоритетно в&nbsp;кратчайшее время.
                                          В&nbsp;зависимости от&nbsp;сложности задачи максимальный временной промежуток
                                          составляет 24&nbsp;часа с&nbsp;момента обращения наших клиентов.</>}/>
                        </div>
                    </div>
                </Card>

                <Card color={'gray'}>
                    <div>Услуга &laquo;Мобильная защита&raquo; (15&nbsp;руб./сут., включая налоги) предоставляется
                        ООО &laquo;ИТ&nbsp;Консул&raquo; на&nbsp;условиях оферты. оплата осуществляется переводом
                        с&nbsp;лиевого счета абонента t2&nbsp;на условиях оферты и&nbsp;условиях оферты ООО &laquo;РНКО
                        Единая касса&raquo;
                    </div>
                    <ul>
                        <li><a href={OFFER_ITK}>Правила абонентского обслуживания ООО &laquo;ИТ&nbsp;Консул&raquo;</a></li>
                        <li><a href={OFFER_T2}>Оферта&nbsp;t2</a></li>
                        <li><a href={OFFER_RNKO}>Оферта ООО &laquo;РНКО Единая касса&raquo;</a></li>
                    </ul>
                </Card>
            </div>
        </div>

        <Footer/>


    </>
);

export default Index;



